/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize exports="amd" -o ./compat/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
define([], function() {

  /** Used internally to indicate various things */
  var indicatorObject = {};

  return indicatorObject;
});



//////////////////
// WEBPACK FOOTER
// ./~/lodash-amd/compat/internals/indicatorObject.js
// module id = 62
// module chunks = 16 17 18 19